import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { installModalScrollReconciler, reconcileModalBodyScroll } from './modal-scroll-state.util';

/**
 * Wires modal body-scroll reconciliation into the app root. Call once, from `App`.
 *
 * Two triggers:
 *  - modal lifecycle events, so one modal's deferred teardown cannot strip state that another
 *    modal still needs;
 *  - route changes, because React unmounts a shown modal without Bootstrap ever running
 *    `hide()`, which strands the scroll lock on `<body>` for the rest of the session.
 *
 * The route effect is a plain `useEffect` (post-commit) so the unmount has already been
 * applied to the DOM before the open-modal count is read.
 */
export const useModalScrollReconciler = (): void => {
  const { pathname } = useLocation();

  useEffect(() => installModalScrollReconciler(), []);

  useEffect(() => {
    reconcileModalBodyScroll();
  }, [pathname]);
};
